import React, { FC, useCallback, useEffect, useState }  from 'react'
import { useSelector, useDispatch } from 'react-redux'
import StreamModal from './StreamModal'
import { mediaType as MediaType } from '@bt-react/constants'
import useInterval from '@bt-react/libs/useInterval'
import { State } from '../../../dataStore/reducers/reducerType'
import { setEventStreamUrl, setMediaType } from '../../../dataStore/actions/room/room'
import { hideStreamModal } from '../../../dataStore/actions/ui/uiActions'
import { EventStreamSlice } from '../../../dataStore/slices/eventStream'
import { setAutoSpotlight } from '../../../dataStore/actions/room/room'
import { fetchEventStreamDetails } from '../../../dataStore/slices/eventStream/eventStreamSlice'
import audit from '../../../lib/audit/audit'
import { addEntry } from '../../../lib/audit'

const StreamModalIndex: FC = () => {
  const streamModalActive = useSelector((state: State) => state.ui.showStreamModal) as boolean
  const eventStream = useSelector((state: State) => state.eventStream) as EventStreamSlice
  const isPresenterLayoutsActive = useSelector((state: State) => state.layouts.presenterLayout.presenterLayoutsActive) as boolean
  const userData = useSelector((state: State) => state.user.data)
  const roomName = useSelector((state: State) => state.config.roomname) as string
  const [ streamLoading, setStreamLoading ] = useState(false)
  const [ showPassword, setShowPassword ] = useState(false)
  const [ streamReady, setStreamReady ] = useState(false)
  const dispatch = useDispatch<any>()

  const toggleShowPassword = () => setShowPassword(!showPassword)

  const launchStream = () => {
    audit.addEntry('PresenterService', 'StreamStartClicked', JSON.stringify({
      userId: userData?.externalIdV2,
      name: `${userData?.firstName} ${userData?.lastName}`,
      localTimestamp: Date.now().toString(),
      cookies: document.cookie,
      browser: {
        vendor: navigator.vendor,
        userAgent: navigator.userAgent
      }
    }))
    dispatch(setMediaType(MediaType.EVENT_STREAM))
    dispatch(setEventStreamUrl(eventStream.streamVideoUrl))
    dispatch(hideStreamModal())
    if(!isPresenterLayoutsActive) dispatch(setAutoSpotlight(true))
  }

  const onCancelClick = () => dispatch(hideStreamModal())

  /*
    When the event stream details are ready, check the stream url.
    If the user is streaming show the video
  */
  const fetchStreamUrl = useCallback(async () => {

    let result: Response

    try {

      result = await fetch(eventStream.streamVideoUrl)

    } catch (e) {

      addEntry('PresenterService', 'EventStreamFetching', `failed to fetch event stream video URL. Error: ${e}`)
      return

    }

    if (result?.status === 200) {

      setStreamReady(true)
      setStreamLoading(false)

    } else if (result?.status === 404) console.clear()

  }, [ eventStream.streamVideoUrl ])

  useEffect(() => {

    if (eventStream.streamVideoUrl === '') return

    setStreamLoading(true)
    fetchStreamUrl()

  }, [ eventStream.streamVideoUrl, fetchStreamUrl ])

  /*
    If the stream details are not present in the store then this
    interval will fire until they are available.
  */
  useInterval(() => {

    if (eventStream.streamVideoUrl !== '') return

    dispatch(fetchEventStreamDetails(roomName))

  }, eventStream.streamVideoUrl === '' ? 2500 : null)

  /*
    If the eventStream details are ready but the user is not yet streaming
    this interval will fire until the stream starts or the component is closed
  */
  useInterval(() => {

    if (eventStream.streamVideoUrl === '') return

    fetchStreamUrl()

  }, !streamReady ? 2500 : null)

  return <StreamModal
    isOpen={streamModalActive}
    streamUrl={eventStream.streamUrl}
    streamKey={eventStream.streamKey}
    streamVideoUrl={eventStream.streamVideoUrl}
    showPassword={showPassword}
    streamReady={streamReady}
    streamLoading={streamLoading}
    launchStream={launchStream}
    onCancelClick={onCancelClick}
    toggleShowPassword={toggleShowPassword}
  />
}

export default StreamModalIndex